//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Annotations.js";
import "../Annotations/Annotations.CenterlineBuilder.js";
import "../no/SelectNXObject.js";
import "../no/SelectNXObjectList.js";
import "../Annotations/Annotations.CircleCenterlineSettingsBuilder.js";
import "../no/SelectObject.js";
import "../no/SelectObjectList.js";
let d=[[[0,"FullCircle",1,0],[1,"Inherit",0,"SelectNXObject",0],[1,"Locations",0,"SelectNXObjectList",0],[1,"Settings",0,"Annotations.CircleCenterlineSettingsBuilder",0],[0,"Type",1,0]],[[["index"],"RemoveLocation",{},1,0]],[]];
SPLM.Annotations.CircleCenterlineBuilder = class extends SPLM.Annotations.CenterlineBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Annotations.CircleCenterlineBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Annotations.CircleCenterlineBuilder.Types = Object.freeze({
    "Through3Points" : "Through3Points", "Centerpoint" : "Centerpoint"});

export default SPLM;